import { render, staticRenderFns } from "./HospitalizedHisInformationItemDefaultSelectBehaviorEditor.vue?vue&type=template&id=4177be6e&scoped=true&"
import script from "./HospitalizedHisInformationItemDefaultSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./HospitalizedHisInformationItemDefaultSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./HospitalizedHisInformationItemDefaultSelectBehaviorEditor.vue?vue&type=style&index=0&id=4177be6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4177be6e",
  null
  
)

export default component.exports